import { Component, OnInit } from '@angular/core';
import { SEOService } from '@app/core/services/seo.service';
import { redirectToAccount } from '@app/shared/helpers/location';
import { Team } from '@app/shared/models/team';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import * as fromRoot from '../../reducers/index';

@Component({
  selector: 'app-request-expired',
  templateUrl: './request-expired.component.html',
  styleUrls: ['./request-expired.component.scss']
})
export class RequestExpiredComponent implements OnInit {
  hasToken$: Observable<boolean>;
  selectedTeam$: Observable<Team>;

  constructor(
    private readonly store$: Store<fromRoot.State>,
    private seoService: SEOService
  ) {
    this.hasToken$ = this.store$.select(fromRoot.getHasToken);
    this.selectedTeam$ = this.store$.select(fromRoot.getActiveTeam);
  }

  ngOnInit(): void {
    this.seoService.removeHreflang();
  }

  async redirectToAccount() {
    const selectedTeam = await this.selectedTeam$.pipe(take(1)).toPromise();
    redirectToAccount(selectedTeam.id);
  }
}
